/**
 * RC-063: aba aberta antes de um deploy continua rodando a build anterior — e a build
 * anterior pode interpretar horário diferente do servidor (22/09: grade em Brasília,
 * servidor em Porto Velho). Cada build carimba um id; `/version.json` (sem cache) diz
 * qual está publicada. Diferente → a aba sabe que está velha.
 */
export const APP_BUILD: string = typeof __APP_BUILD__ === 'string' ? __APP_BUILD__ : 'dev';

export async function fetchPublishedBuild(fetcher: typeof fetch = fetch): Promise<string | null> {
  try {
    const res = await fetcher(`/version.json?t=${Date.now()}`, { cache: 'no-store' });
    if (!res.ok) return null;
    const body = (await res.json()) as { build?: unknown };
    return typeof body.build === 'string' && body.build ? body.build : null;
  } catch {
    return null;
  }
}

export function isOutdated(published: string | null, current: string = APP_BUILD): boolean {
  return published !== null && current !== 'dev' && published !== current;
}

/**
 * Story 65.45: o login que devolve trabalho guardado não recarrega a página (exceção ao guarda
 * da RC-063) e pede a conferência da versão na hora, em vez de esperar o próximo foco da janela.
 */
export const VERSION_CHECK_EVENT = 'valiosas:conferir-versao';

export function requestVersionCheck(): void {
  window.dispatchEvent(new Event(VERSION_CHECK_EVENT));
}
